<div class="content-wrapper">
    <h3>{{ sequenceTitle }}</h3>
    @if(title) {
    <h4>{{ title }}</h4>
    }
    <p class="introText">{{ bodyText }}</p>
    @if(imageUrl) {
    <div class="introImage">
        <img class="introImage" [src]="imageUrl">
    </div>
    }
    @if(footerText) {
    <p class="introText">{{ footerText }}</p>
    }
    <tracker-buttons></tracker-buttons>
</div>